import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H4, H6 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Wrapper = styled.div`
    display: block;

    ${H4} {
        display: inline-block;
        margin-bottom: 4px;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${H4} {
            display: none;
        }
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: baseline;

    & > p {
        display: inline-block;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        & > p {
            display: none;
        }
    }
`;

export const Clearfix = styled.div`
    display: block;
    zoom: 1;

    &:before,
    &:after {
        content: "";
        display: table;
    }

    &:after {
        clear: both;
    }
`;

export const SpeedItem = styled.div`
    display: block;
    width: 80px;
    flex-grow: 1;
    text-align: center;

    ${Paragraph4} {
        display: none;
        color: ${COLORS.TextInfo};
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${Paragraph4} {
            display: block;
        }

        ${H4} {
            margin-bottom: 0;
        }
    }
`;

export const Block = styled.div`
    display: block;

    margin-top: 4px;

    & > ${SpeedItem}:nth-child(1) {
        float: left;
        text-align: left;
    }

    & > ${SpeedItem}:nth-child(2) {
        float: right;
        text-align: right;
    }

    ${H6} {
        color: ${COLORS.TextInfo};
    }

    ${H4} {
        display: none;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        margin-top: 12px;

        ${H6} {
            display: none;
        }

        ${H4} {
            display: block;
        }
    }
`;

export const SpeedsWrapper = styled.div<{ $isOdd: boolean }>`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0;
    align-items: center;
    justify-content: space-between;

    ${({ $isOdd }) => $isOdd
            ? css`
                ${SpeedItem}:nth-child(odd) {
                    visibility: hidden;
                }
            `
            : ''
    }
`;
